import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=407a3286&scoped=true"
import script from "./section-title.vue?vue&type=script&lang=js"
export * from "./section-title.vue?vue&type=script&lang=js"
import style0 from "./section-title.vue?vue&type=style&index=0&id=407a3286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407a3286",
  null
  
)

export default component.exports